var _ = require('underscore');
module.exports = function(options){
var __t,__p='',__j=Array.prototype.join,print=function(){__p+=__j.call(arguments,'');};
__p+='';
 let { altText, imgSrc, index} = options; 
__p+='\n\n';
 if (typeof altText === 'string' && altText) { 
__p+='\n    <img data-src="'+
((__t=( imgSrc ))==null?'':__t)+
'" class="hide owl-lazy"index="'+
((__t=( index ))==null?'':__t)+
'" alt="'+
((__t=( altText ))==null?'':__t)+
'" title="'+
((__t=( altText ))==null?'':__t)+
'">\n';
 } else { 
__p+='\n    <img data-src="'+
((__t=( imgSrc ))==null?'':__t)+
'" class="hide owl-lazy"index="'+
((__t=( index ))==null?'':__t)+
'">\n';
 } 
__p+='\n';
return __p;
};



// WEBPACK FOOTER //
// ./local/templates/community_photo_gallery.jst.ejs